import React from "react";
import fp from "lodash/fp";
import { FormGroup } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { reduxForm, SubmissionError, Field, getFormValues } from "redux-form";

import { OnlineLink, Button } from "components";
import { LoginFormName, ValidationMessages } from "globalConstants";
import { getErrorMessage } from "helpers";
import { useCheckCredentialsMutation } from "queries";
import { userActions } from "store";
import { requiredWithMessage } from "validators";

import FormInputGroup from "./formInputGroup";
import Policy from "./policy";

import styles from "./login.module.scss";

const PasswordForm = ({
	next,
	handleSubmit,
	submitting,
	handleLogin,
	isEmailUnique,
}) => {
	const dispatch = useDispatch();

	const username = useSelector(
		fp.flow(getFormValues(LoginFormName), fp.get("username")),
	);

	const {
		mutateAsync: getCheckCredentials,
		isLoading: isLoadingCredentials,
	} = useCheckCredentialsMutation();

	const handleSubmitPassword = async ({ username, password }) => {
		if (username && password) {
			const {
				data: { is_valid },
			} = await getCheckCredentials({
				username,
				password,
			});

			if (is_valid) {
				if (isEmailUnique) {
					return dispatch(userActions.login(username, password))
						.then(() => {
							return handleLogin();
						})
						.catch(err => {
							throw new SubmissionError({
								password: getErrorMessage(err),
							});
						});
				} else {
					return next();
				}
			} else {
				throw new SubmissionError({
					password: getErrorMessage(
						ValidationMessages.InvalidPassword,
					),
				});
			}
		}
	};

	return (
		<form onSubmit={handleSubmit(handleSubmitPassword)}>
			<OnlineLink
				className="right"
				to={{ pathname: "/forgot-password", state: { username } }}
			>
				Forgot password?
			</OnlineLink>
			{/* For browser autocomplete */}
			<Field component="input" type="hidden" name="username" />
			<Field
				component={FormInputGroup}
				type="password"
				autoComplete="current-password"
				label="Password"
				name="password"
				id="password"
				placeholder="Enter your password"
				autoFocus
				validate={requiredWithMessage("Password cannot be empty")}
			/>
			<Policy />
			<FormGroup className="col-md-12 text-center">
				<Button
					type="submit"
					disabled={submitting || isLoadingCredentials}
					className={styles.nextBtn}
					value="Next"
				/>
			</FormGroup>
		</form>
	);
};

export default reduxForm({
	form: LoginFormName,
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: true,
})(PasswordForm);
